import { Stack, Text } from '@mantine/core';
import { useLocalizedCurrencyFormatter } from 'shared/utils/currency';
import type { CurrencyCode } from 'types/currency';
import type { LightInvoice } from 'types/store/invoice-state';

type LightInvoiceItemProps = {
  item: LightInvoice;
  currency?: CurrencyCode;
};

export const LightInvoiceItem = ({
  item: { reference, total_tvac, remaining_balance_with_fees },
  currency,
}: LightInvoiceItemProps) => {
  const formatter = useLocalizedCurrencyFormatter(false, currency);
  return (
    <Stack gap={0}>
      <Text fw={900}>{reference}</Text>
      <Text size="xs" c="gray.6">
        {total_tvac && <span>{formatter.format(total_tvac)}</span>}
        {total_tvac && remaining_balance_with_fees && ' / '}
        {remaining_balance_with_fees && <b>{formatter.format(-remaining_balance_with_fees)}</b>}
      </Text>
    </Stack>
  );
};
